import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export const usePaypal = () => {
  const store = useStore();
  const router = useRouter();

  const initPayPalButton = () => {
    const suscripcion = store.state.Subscription.suscripcion_efectivo;
    store.dispatch('saveSuscEfectivo', suscripcion);

    setTimeout(() => {
      const { folio } = store.state.Subscription.subscriber_registration.dataObj;
      
      paypal.Buttons({
        style: {
          shape: 'pill',
          color: 'gold',
          layout: 'horizontal',
          label: 'paypal',
          tagline: false,
        },
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [{
              reference_id: folio,
              invoice_id: folio,
              custom_id: folio,
              amount: {
                currency_code: 'MXN',
                value: suscripcion,
                breakdown: {
                  item_total: {
                    currency_code: 'MXN',
                    value: suscripcion,
                  },
                },
              },
              items: [{
                name: 'Servicios DISH DIGITAL',
                quantity: '1',
                category: 'DIGITAL_GOODS',
                unit_amount: {
                  currency_code: 'MXN',
                  value: suscripcion,
                },
              }],
            }],
          });
        },
        onApprove: async (data, actions) => {
          const peticion = { folio, monto: suscripcion };
          const respuesta = await store.dispatch('tranOrderId', peticion);

          return actions.order.capture().then(async (orderData) => {
            await store.dispatch('saveIdPaypal', orderData.id);

            const pet = {
              folio: String(folio),
              monto: String(suscripcion),
              orderIdDish: String(respuesta.orderid),
              orderIdPaypal: String(orderData.id),
              estatus: String(orderData.status),
              request: JSON.stringify(orderData.purchase_units),
              response: JSON.stringify(orderData),
              canalPago: String(1)
            };

            await store.dispatch('tran_paypal', pet);
            await store.dispatch('setRegisterMethod', { paymentMethod: 'paypal' });
            router.push({ name: 'Resumen' });
          });
        },
        onError: (err) => {
          const element = document.getElementById('paypal-button-container');
          element.innerHTML = '<p>Ocurrió un error con el pago, favor de validar.</p>';
        },
      }).render('#paypal-button-container');
    }, 100);
  };

  return {
    initPayPalButton
  };
};
